import Door from '!url-loader!@img/icons/door.svg';
import Fuel from '!url-loader!@img/icons/fuel.svg';
import Mileage from '!url-loader!@img/icons/mileage.svg';
import Transmission from '!url-loader!@img/icons/transmission.svg';
import Type from '!url-loader!@img/icons/type.svg';
import { getImageUrl } from '@helpers/image';
import { clamp } from '@helpers/utils';
import { withRedux } from '@hoc/withRedux';
import { ReactComponent as SvgCamera } from '@img/icons/camera.svg';
import { ReactComponent as ControlArrow } from '@img/icons/cta-chevron.svg';
import { ReactComponent as LocationPin } from '@img/icons/location-pin.svg';
import { ReactComponent as ShortlistRemove } from '@img/icons/shortlist-remove.svg';
import { ReactComponent as Shortlist } from '@img/icons/shortlist.svg';
import { toggle } from '@redux/reducers/shortlist';
import { useAppDispatch, useAppSelector } from '@redux/store';
import Tag from '@stories/Components/Tag/Tag';
import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import CarouselButtons from '../CarouselButtons/CarouselButtons';
import { UsedCarStyles as S } from './UsedCar.styles';
const UsedCar = ({ id, bikeType, carType, disableImageProcessing = false, doors, doorsIconUrl = Door, carTypeIconUrl = Type, fuelType, fuelTypeIconUrl = Fuel, images, imageRatio = '4:3', altText, listView = false, location, mileage, mileageIconUrl = Mileage, monthlyPrice, monthlyPriceLabel = 'Monthly Price', price, priceLabel = 'Price', reserved, sold = false, strapline, subtitle, tag, title, transmission, transmissionIconUrl = Transmission, url, }) => {
    const dispatch = useAppDispatch();
    const { items } = useAppSelector((state) => state.shortlist.persisted);
    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const maxIndex = images ? images.length - 1 : 0;
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => handleNextClick(),
        onSwipedRight: () => handlePreviousClick(),
    });
    const isInShortlist = items.some((item) => item.id.toString() === id.toString());
    return (React.createElement(S.Container, { listView: listView, "data-image-ratio": imageRatio },
        images && images.length > 0 && (React.createElement(S.ImageContainer, { ...swipeHandlers, ref: (r) => {
                swipeHandlers.ref(r);
            } },
            renderTag(),
            images.length > 1 && (React.createElement(S.ImageCount, null,
                React.createElement("span", null,
                    React.createElement(SvgCamera, null)),
                React.createElement("span", null,
                    activeImageIndex + 1,
                    " / ",
                    images.length))),
            React.createElement(S.UnstyledLink, { as: sold ? 'span' : 'a', href: sold ? undefined : url, title: sold ? undefined : `View This ${bikeType ? 'Bike' : 'Car'}` }, images.map((image, i) => {
                const prevIndex = activeImageIndex - 1;
                const nextIndex = activeImageIndex + 1;
                if (activeImageIndex === i) {
                    return renderImage(image, i);
                }
                if (prevIndex >= 0 && i === prevIndex) {
                    return renderImage(image, prevIndex);
                }
                if (nextIndex < images.length && i === nextIndex) {
                    return renderImage(image, nextIndex);
                }
                return null;
            })),
            images.length > 1 && (React.createElement(CarouselButtons, { prevDisabled: activeImageIndex === 0, prevClicked: handlePreviousClick, nextDisabled: activeImageIndex === maxIndex, nextClicked: handleNextClick })))),
        React.createElement(S.UnstyledLink, { as: sold ? 'span' : 'a', href: sold ? undefined : url, title: sold ? undefined : `View This ${bikeType ? 'Bike' : 'Car'}` },
            React.createElement(S.ContentContainer, null,
                title && React.createElement(S.Title, null, title),
                subtitle && React.createElement(S.Subtitle, null, subtitle),
                strapline && React.createElement(S.Strapline, null, strapline),
                React.createElement(S.PriceContainer, null,
                    (reserved || sold || price) && (React.createElement(S.PriceItem, null,
                        React.createElement(S.PriceLabel, null, priceLabel),
                        reserved || sold ? React.createElement(S.Price, null, "Not Available") : React.createElement(S.Price, null, price))),
                    (reserved || sold || monthlyPrice) && (React.createElement(S.PriceItem, null,
                        React.createElement(S.PriceLabel, null, monthlyPriceLabel),
                        reserved || sold ? (React.createElement(S.Price, null, "Not Available")) : (React.createElement(S.Price, null, monthlyPrice))))))),
        React.createElement(S.FeaturesContainer, null,
            React.createElement(S.Features, null,
                fuelType && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: fuelTypeIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, fuelType))),
                transmission && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: transmissionIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, transmission))),
                doors && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: doorsIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, doors))),
                mileage && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: mileageIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, mileage))),
                carType && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: carTypeIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, carType))),
                bikeType && (React.createElement(S.Feature, null,
                    React.createElement(S.FeatureIconImage, { src: carTypeIconUrl ?? '' }),
                    React.createElement(S.FeatureText, null, bikeType))),
                !sold && location && (React.createElement(S.LocationContainer, null,
                    React.createElement(S.LocationIcon, null,
                        React.createElement(LocationPin, null),
                        React.createElement(S.LocationTooltip, null,
                            "Currently at ",
                            location))))),
            React.createElement(S.LinkContainer, null,
                React.createElement(S.ShortlistContainer, { added: isInShortlist, onClick: () => {
                        dispatch(toggle({ id: id, name: title, image: images?.[0] }));
                    } }, isInShortlist ? React.createElement(ShortlistRemove, null) : React.createElement(Shortlist, null)),
                React.createElement(S.Link, { as: sold ? 'span' : 'a', href: sold ? undefined : url },
                    "View This ",
                    bikeType ? 'Bike' : 'Car',
                    " ",
                    React.createElement(ControlArrow, null))))));
    function renderImage(image, index) {
        const ratioValue = imageRatio === '16:9' ? 9 / 16 : 3 / 4;
        const imageSrc = disableImageProcessing
            ? image
            : getImageUrl(image, { mode: 'crop', width: 420, heightratio: ratioValue });
        const srcs = [
            `${imageSrc} 1x`,
            `${getImageUrl(image, { mode: 'crop', width: 840, heightratio: ratioValue })} 2x`,
        ];
        return (React.createElement(S.Image, { loading: "lazy", alt: altText ?? '', role: altText ? undefined : 'presentation', src: imageSrc, ...(disableImageProcessing ? {} : { srcSet: srcs.join(',') }), "data-active": index === activeImageIndex }));
    }
    function renderTag() {
        if (tag) {
            return React.createElement(Tag, { title: tag });
        }
        if (sold) {
            return React.createElement(Tag, { title: "Sold" });
        }
        if (reserved) {
            return React.createElement(Tag, { title: "Reserved" });
        }
        return null;
    }
    function handleNextClick() {
        if (activeImageIndex === maxIndex) {
            setActiveImageIndex(0);
        }
        else {
            setActiveImageIndex(clamp(activeImageIndex + 1, maxIndex));
        }
    }
    function handlePreviousClick() {
        if (activeImageIndex === 0) {
            setActiveImageIndex(maxIndex);
        }
        else {
            setActiveImageIndex(clamp(activeImageIndex - 1, maxIndex));
        }
    }
};
export default withRedux(UsedCar);
